/**
 * Helpers puros del storage de comprobantes de movimientos de cuenta.
 * Separado del repo para poder testearlo sin arrastrar supabaseClient.
 */

export const CUSTOMER_MOVEMENT_ATTACHMENTS_BUCKET = 'customer-movement-attachments';

export function customerMovementAttachmentExtension(mimeType: string): string {
  if (mimeType.startsWith('image/png')) return 'png';
  if (mimeType.startsWith('image/jpeg') || mimeType.startsWith('image/jpg')) return 'jpg';
  if (mimeType === 'application/pdf') return 'pdf';
  return 'bin';
}

/** Path org-scoped: `${orgId}/${movementId}/${attachmentId}.${ext}` (RLS de storage). */
export function buildCustomerMovementAttachmentStoragePath(params: {
  orgId: string;
  movementId: string;
  attachmentId: string;
  mimeType: string;
}): string {
  const ext = customerMovementAttachmentExtension(params.mimeType);
  return `${params.orgId}/${params.movementId}/${params.attachmentId}.${ext}`;
}
